import { heroStats } from '../data';
import s from './Hero.module.css';

const IconMobile = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect x="5" y="2" width="14" height="20" rx="2"/><line x1="12" y1="18" x2="12.01" y2="18"/>
  </svg>
);
const IconWeb = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/>
  </svg>
);
const IconCloud = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"/>
  </svg>
);
const IconDesign = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
  </svg>
);

const HERO_CARDS = [
  { Icon: IconMobile, title: 'Mobile Apps',   sub: 'iOS & Android'   },
  { Icon: IconWeb,    title: 'Web Apps',       sub: 'React · Node.js' },
  { Icon: IconCloud,  title: 'Cloud / DevOps', sub: 'AWS · Docker'    },
  { Icon: IconDesign, title: 'UI/UX Design',   sub: 'Figma · Systems' },
];

export default function Hero() {
  return (
    <section id="about" className={s.hero} aria-label="Hero">
      <div className={s.inner}>

        {/* ── Left col ── */}
        <div>
          <div className={`${s.pill} fade-up d1`}>
            <span className={s.dot} />
            <span>Dubai-Based · Global Delivery</span>
          </div>
          <h1 className={`${s.headline} fade-up d2`}>
            We Turn Ideas Into<br />Digital Reality
          </h1>
          <p className={`${s.sub} fade-up d3`}>
            A friendly team of developers, designers &amp; strategists who love
            building products that make a real difference.
          </p>
          <div className={`${s.btns} fade-up d4`}>
            <a href="#services" className="btn-dark">Explore Our Work ↗</a>
            <a href="#contact"  className="btn-dark-ghost">Say Hello 👋</a>
          </div>
          <div className={`${s.statsGrid} fade-up d5`}>
            {heroStats.map(({ value, label }) => (
              <div key={label} className={s.statBox}>
                <div className={s.statVal}>{value}</div>
                <div className={s.statLbl}>{label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* ── Right col — visual card ── */}
        <div className={`${s.visual} fade-up d3`}>
          <div className={s.visualCard}>

            {/* Top: pill + big word (flex-grow to fill space) */}
            <div style={{ flexShrink: 0 }}>
              <div className={s.availPill}>
                <span className={s.dot} />
                <span>Available for new projects</span>
              </div>
            </div>

            <div className={s.bigWord}>NEXT IT ERA</div>

            {/* Bottom: 4 mini cards — always visible */}
            <div className={s.miniGrid}>
              {HERO_CARDS.map(({ Icon, title, sub }) => (
                <div key={title} className={s.miniCard}>
                  <div className={s.miniIcon}><Icon /></div>
                  <div className={s.miniTitle}>{title}</div>
                  <div className={s.miniSub}>{sub}</div>
                </div>
              ))}
            </div>

          </div>

          {/* Floating badge */}
          <div className={s.badge}>
            <div className={s.badgeVal}>100%</div>
            <div className={s.badgeLbl}>On-time delivery</div>
            <div className={s.badgeSince}>Since 2017</div>
          </div>
        </div>

      </div>
    </section>
  );
}